import type { FC } from 'react';

import { ImageComponentForThumbnail } from '@weberus/ui/components/image-component-for-thumbnail';
import { Thumbnail, MembershipBadge, ProductBadge } from '@yanolja-rnd/nol-design-system';

interface ThumbnailSectionProps {
  imageUrl: string;
  hasGoldClassBadge?: boolean;
  bottomBadgeText?: string;
}

export const ThumbnailSection: FC<ThumbnailSectionProps> = ({ imageUrl, hasGoldClassBadge, bottomBadgeText }) => (
  <Thumbnail
    alt=""
    className="relative mb-10 pc:mb-16"
    image={imageUrl}
    imageComponent={ImageComponentForThumbnail}
    ratio="3_4"
    shape={{
      mobile: 'roundedRectangle_8',
      pc: 'roundedRectangle_16',
    }}
  >
    {!!hasGoldClassBadge && (
      <div className="absolute left-4 top-4 pc:left-12 pc:top-12">
        <MembershipBadge type="gold" />
      </div>
    )}
    {!!bottomBadgeText && (
      <div className="absolute bottom-0 left-0">
        <ProductBadge radius="topRightBottomLeft" type="filled_blackop">
          {bottomBadgeText}
        </ProductBadge>
      </div>
    )}
  </Thumbnail>
);
